import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { GoogleAuthButton, OrDivider, useAuthConfig } from '../components/auth/GoogleAuthButton';
import { showLoginError } from '../lib/authFlows';
import { isNative } from '../lib/mobile';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Heart, Loader2 } from 'lucide-react';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, loginWithGoogle, isLoading } = useAuthStore();
  const gcfg = useAuthConfig('/api/auth');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error('Lütfen tüm alanları doldurun');
      return;
    }

    try {
      goPanel(await login(email, password));
    } catch (error) {
      showLoginError(error, '/api/auth', email);
    }
  };

  const goPanel = (user) => {
    toast.success('Giriş başarılı!');
    if (user.role === 'admin') navigate('/admin');
    else if (user.user_type === 'salon_owner') navigate('/salon');
    else if (user.user_type === 'albumcu') navigate('/albumcu');
    else navigate('/panel');
  };

  const onGoogle = async (credential) => {
    try {
      goPanel(await loginWithGoogle(credential));
    } catch (error) {
      toast.error(error.message, { duration: 8000 });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2 mb-6">
            <Heart className="h-8 w-8 text-primary" />
            <span className="text-2xl font-bold gradient-text">WeddingTakip</span>
          </Link>
          <h1 className="text-2xl font-semibold mb-2">Hoş Geldiniz</h1>
          <p className="text-muted-foreground">Hesabınıza giriş yapın</p>
        </div>

        <div className="bg-card border border-border rounded-2xl p-6 sm:p-8 shadow-sm">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email">E-posta</Label>
              <Input
                id="email"
                type="email"
                placeholder="ornek@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
                data-testid="login-email-input"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Şifre</Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
                data-testid="login-password-input"
              />
            </div>

            <Button 
              type="submit" 
              className="w-full" 
              disabled={isLoading}
              data-testid="login-submit-btn"
            >
              {isLoading ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  Giriş yapılıyor...
                </>
              ) : (
                'Giriş Yap'
              )}
            </Button>
          </form>

          <div className="mt-3 text-right">
            <Link to="/sifremi-unuttum" className="text-sm text-primary hover:underline" data-testid="forgot-pw-link">Şifremi unuttum</Link>
          </div>

          {gcfg?.client_id && !isNative() && (
            <>
              <OrDivider />
              <GoogleAuthButton apiBase="/api/auth" onCredential={onGoogle} testId="wedding-google-login" />
            </>
          )}

          <div className="mt-6 text-center">
            <p className="text-sm text-muted-foreground">
              Hesabınız yok mu?{' '}
              <Link to="/kayit" className="text-primary hover:underline font-medium">
                Kayıt Ol
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
